export enum CallForTendersState {
  Draft = "DRAFT",
  Active = "ACTIVE",
  Finished = "FINISHED",
  Completed = "COMPLETED",
  Opened = "OFFERS_OPENED",
}
